/// ////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////
/// ////////////////////// English /////////////////////////////
/// ////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////
import { DASH_LINKS } from "../../../const/AppCardLinks";
/* eslint-disable */
// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <b>EngagED Parent Portal Login Process (Internal/External)</b>,
    Interrupt_p1: (
        <>
            To log in to the EngagED Parent Portal, you will pair your <b>Infinite Campus Parent Portal username</b>{" "}
            (external parent: username you created during account setup) <u>and</u> <b>@p.dcsdk12.org</b>. For example:
            if your Infinite Campus username is <b>jsmith</b>, you will enter <b>jsmith@p.dcsdk12.org</b> as your email
            address on the login screen that follows. Your <b>password</b> is the same one you use for accessing
            Infinite Campus (external parent: password you created during account setup).
        </>
    ),
    Interrupt_p2: (
        <>
            <b>If you have forgotten your DCSD login credentials</b>:<br />
            Use these links to{" "}
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/forgotuserid.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                retrieve your username
            </a>{" "}
            and/or{" "}
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/kiosk.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                reset your password
            </a>
            .
        </>
    ),
    Interrupt_p3: (
        <>
            <b>If you have followed the steps above and continue to have difficulty, please contact us</b>
            :<br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Parent Tech Support - English
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Parent Tech Support - Spanish
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Parent Tech Support - Chinese
            </a>
            <br />
            IT Support Center at <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "NOTE: District employees who are current parents should follow the instructions above using an incognito or private browser window and/or different browser.",
    Interrupt_submit: "Proceed to Login",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Welcome,",
    Main_Nav_HelpfulLinks: "Helpful Links",
    Main_Nav_LogOut: "LOGOUT",
    Main_Nav_HelpfulLinks_LI_s1: "Contact My Student(s) Nurse",
    Main_Nav_HelpfulLinks_LI_s2: "Academic Calendars",
    Main_Nav_HelpfulLinks_LI_s3: "Parent Resources",
    Main_Nav_HelpfulLinks_LI_s4: "Bus Routes",
    Main_Nav_HelpfulLinks_LI_s5: "Online Payments",
    Main_Nav_HelpfulLinks_LI_s6: "Lunch Menus",
    Main_Nav_Exit: "EXIT",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "Add",
    Global_Add_New_Student: "Add New Student",
    Global_BackToDashboard: "Back to Dashboard",
    Global_Close: "Close",
    Global_Completed: "Completed",
    Global_InProgress: "In Progress",
    Global_GoTo: "Go To",
    Global_MoreInfo: "More Info",
    Global_No_Student_1: "Welcome to the EngagED Parent Portal",
    Global_No_Student_2: "Sorry, we are unable to find any students associated to your account.",
    Global_No_Student_External: (
        <>
            If you are applying for Open Enrollment, please click the &ldquo;<strong>Add New Student</strong>&rdquo;
            button to add your student. If you are applying for multiple students, you will add each student
            individually.
        </>
    ),
    Global_No_Student_Guardian: (
        <>
            If you do not see your student(s) and they are currently enrolled in a DCSD school, please contact the IT
            Support Center at <strong>303-387-0001</strong>. Please only use the &ldquo;<strong>Add New Student</strong>
            &rdquo; button to add your student if they are not currently enrolled in a DCSD school and you are applying
            for Open Enrollment.
        </>
    ),
    Global_NotStarted: "Not Started",
    Global_Open: "Open",
    Global_OpenFrom: "Open From", // <some date> - <some date>
    Global_Status: "Status",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "DCSD Guardian Dashboard",
    Breadcrumb_EPR: "DCSD Guardian",
    Breadcrumb_Translations: "Translations are experimental",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// EPR /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Failure1: "Sorry, we are unable to retrieve the EPR PDF for the student",
    EPR_Failure2: "Please provide the following information when contacting the district for support:",
    EPR_NoData: "No historical EPRs found for the student.",
    EPR_Success: "EPR PDF retrieved successfully for the student.",
    EPR_Title: "Archived EPR Resources",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// No Apps /////////////////////////////
    /// /////////////////////////////////////////////////////////
    NoApp_Body1: "All application windows are currently closed.",
    NoApp_Body2: "If you feel this is in error, please contact the district for support.",
    NoApp_Closed: "Closed",
    NoApp_Header: "No Applications Available",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Welcome Page ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Welcome_Header: "Welcome to the DCSD Guardian Dashboard",
    Welcome_Tagline: "Partnering with parents to select the best learning environment for every student.",
    Welcome_p1: (
        <p>
            We empower families to find the best educational fit for their children.{" "}
            <a
                href="https://www.dcsdk12.org/schools-academics/schools/school-locator-map"
                rel="noreferrer"
                target="_blank"
            >
                Learn More
            </a>
        </p>
    ),
    Welcome_p2: (
        <p>
            Families who wish to enroll their student in a school other than their neighborhood school must use this
            tool to request Open Enrollment during one of two open enrollment periods DCSD offers annually.{" "}
            <span className="highlight">
                You do not need to use this open enrollment tool to stay at your school of <b>current enrollment</b>.
            </span>
        </p>
    ),
    Welcome_h5_1: (
        <h5>
            <a
                href="https://docs.google.com/document/d/1sr3ARzZGUmmJdNSjlWnLM0QWj8ipKHJb3RkwLr72_P0/edit"
                rel="noreferrer"
                target="_blank"
            >
                Click here
            </a>{" "}
            for step by step instructions on how to use the tool.
        </h5>
    ),
    Welcome_ImportantDates: "Important Dates/Times",
    Welcome_FirstWindow: "First Window",
    Welcome_SecondWindow: "Second Window",
    Welcome_ul_li1a: "First round open enrollment is NOT first-come, first-served; you have until", // <some date>
    Welcome_ul_li1b: "to complete this process.",
    Welcome_ul_li2a: "For first round, you can change your open enrollment request choices at any time until", // <some date>
    Welcome_ul_li3: "Schools will make offers to families based on space availability.",
    Welcome_ul_li4a: "Offers will not be visible to you until after", // <some date>
    Welcome_ul_li4b: (
        <>
            You can log back into{" "}
            <a href={DASH_LINKS.guardian}>
                EngagED Parent Portal
            </a>{" "}
            on or after
        </>
    ), // <some date>
    Welcome_ul_li4c: "to check on any offers you may have received.",
    Welcome_ul_li5a: "You have until", // <some date>
    Welcome_ul_li5b: (
        <>
            to accept an open enrollment offer from a school through the{" "}
            <a href={DASH_LINKS.guardian}>
                EngagED Parent Portal.
            </a>
        </>
    ),
    Welcome_ul_li6a:
        "If your open enrollment request is not accepted by any school, or you didn't log in and accept your offer, you will automatically be placed on the second round open enrollment waitlist, which runs from", // <some date range>
    Welcome_NotAvailable: "Open Enrollment process for the current school year is not yet available.",
    Welcome_PreschoolInfo: "Kindergarten/Preschool Information",
    Welcome_Note: "NOTE",
    Welcome_NoSupport: "This application does not support applying to DCSD preschools.",
    Welcome_PreschoolsLink: (
        <>
            For DCSD preschools,{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/preschool" rel="noreferrer" target="_blank">
                <b>click this link</b>.
            </a>
        </>
    ),
    Welcome_PreschoolEnrollment: (
        <>
            Parents wishing to enroll their three & four year olds in district preschools do not go through open
            enrollment. Preschool registration will take place in early January. Follow this{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/kindergarten" rel="noreferrer" target="_blank">
                <b>link</b>{" "}
            </a>
            for more information.
        </>
    ),
    Welcome_CharterSchoolInfo: "Charter School Information",
    Welcome_CharterSchoolInclude: (
        <>
            <h5>The following Charter Schools will be utilizing the tool this year:</h5>
            <a
                href="https://www.dcsdk12.org/schools_academics/schools/charter_schools"
                rel="noreferrer"
                target="_blank"
            >
                <u>
                    Please contact all other Charter schools directly to learn more about enrollment options for charter
                    schools.
                </u>
            </a>
            <ul className="charter-school-li">
                <li>
                    <i>Aspen View Academy</i>
                </li>
                <li>
                    <i>Ben Franklin Academy</i>
                </li>
                <li>
                    <i>Challenge to Excellence</i>
                </li>
                <li>
                    <i>DCS Montessori Charter</i>
                </li>
                <li>
                    <i>Leman Academy of Excellence</i>
                </li>
                <li>
                    <i>Parker Performing Arts School</i>
                </li>
                <li>
                    <i>SkyView Academy</i>
                </li>
                <li>
                    <i>STEM Academy</i>
                </li>
                <li>
                    <i>World Compass Academy</i>
                </li>
            </ul>
        </>
    ),
    Welcome_TransportationInfo: "Transportation Information",
    Welcome_TransportationBody:
        "Transportation for resident students granted permission to attend a school or program outside their neighborhood attendance area shall be furnished by their parent/guardian.",
    Welcome_GeneralInfo: "General Information",
    Welcome_GeneralInfo_ul2_li1:
        "You may request that a confirmation email be sent to you after your request has been submitted.",
    Welcome_GeneralInfo_ul2_li2:
        "You can choose to have your choices emailed to you after you have completed open enrollment.",
    Welcome_GeneralInfo_ul2_li3:
        "Second round open enrollment is &lquot;first come first served.&rquot; Students requesting open enrollment only in the second round are placed on the waitlist behind those that are currently on the waitlist from first round.",
    Welcome_GeneralInfo_ul2_li4: (
        <>
            If you are open enrolled at a neighborhood school or attend a charter but would like to return to the
            neighborhood school associated with your address for the next school year you must file an{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                intent to return form
            </a>{" "}
            <b>by</b>
        </>
    ), // <some date>,
    Welcome_GeneralInfo_li5: (
        <>
            If you are moving within the district but would like to remain at your current school, you may do so by
            filing an{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                intent to remain
            </a>{" "}
            form at any time.
        </>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////// Marquee /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Marquee_Grade: "Grade",
    Marquee_School: "School",
    Marquee_Address: "Address",
    Marquee_NewStudent: "New Student",
    Marquee_NotAvailable: "Not Available",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Open Enrollment App /////////////////////
    /// /////////////////////////////////////////////////////////
    OEApp_Header: "Open Enrollment",
    OEApp_Btn1: "Start Open Enrollment",
    OEApp_Btn2: "Manage School Choices",
    OEApp_Btn3: "View Student Info",
    OEApp_Btn4: "Edit Student Info",
    OEApp_Btn5: "Select School Choices",
    OEApp_Btn6: "Go to Open Enrollment",
    OEApp_Schools: "School Choices Made",
    OEApp_School: "School Choice Made",
    OEApp_NoSchools: "No School Choices Made",
    OEApp_1School: "1 School Choice Made",
    OEApp_MoreSchools: "School Choices Made",
    OEApp_Body:
        "Application process for parents to elect enrollment consideration for their student(s) at DCSD neighborhood and charter schools.",
    OEApp_Round1: "Round 1",
    OEApp_Round2: "Round 2",
    OEApp_RoundClosed: "Round 1 closed. Please come back for Round 2 starting", // <some date>
    OEApp_SchoolChoices: "School Choices",
    OEApp_RequestStatus: "Request Status",
    OEApp_LanguageChoice: "Language Choice",
    OEApp_KinderChoice: "Kinder Choice",
    OEApp_LanguageOffer: "Language Offer",
    OEApp_KinderOffer: "Kinder Offer",
    OEApp_FullDay: "Full Day",
    OEApp_HalfDayPM: "Half Day PM",
    OEApp_HalfDayAM: "Half Day AM",
    OEApp_Spanish: "Spanish",
    OEApp_Mandarin: "Mandarin",
    OEApp_French: "French",
    OEApp_NewStudent: "New Student",
    OEApp_ACCEPT_OFFER: "Accepted Offer",
    OEApp_CANCELLED_REQUEST: "Cancelled Request",
    OEApp_CHANGED_ENROLLMENT: "Unenrolled",
    OEApp_CHOICE_CREATED: "School Choice Created",
    OEApp_CHOICE_INCOMPLETE: "Choice Incomplete",
    OEApp_DENY_OFFER: "Denied Offer",
    OEApp_DENY_REQUEST: "Denied Request",
    OEApp_ENROLLED: "Enrolled",
    OEApp_INVALID: "Invalid",
    OEApp_MAKE_OFFER: "Offer Made",
    OEApp_MAKE_OFFER_PENDING: "Make Offer Pending",
    OEApp_NO_RESPONSE: "No Response",
    OEApp_WAIT_LIST: "On Wait List",
    OEApp_REQUEST: "Request Made",
    OEApp_UNENROLLED: "Unenrolled",
    OEApp_UNAVAILABLE: "Unavailable",
    /// /////////////////////////////////////////////////////////
    /// ///////////// Express Check-In App //////////////////////
    /// /////////////////////////////////////////////////////////
    ECApp_Header: "Express Check-In",
    ECApp_Btn1: "Go to Express Check-In",
    ECApp_Body:
        "Annual student check-in process for parents to update and/or verify current information for household address, media consent, emergency contacts, health conditions and much more.",
    /// ////////////////////////////////////////////////////////
    /// ///////// Elementary Progress Report App ///////////////
    /// ////////////////////////////////////////////////////////
    EPRApp_Body: "Coming Soon. View your student's Elementary Progress Report.",
    EPRApp_Header: "Elementary Progress Report",
    EPRApp_Btn1: "Go to EPR",
    EPRApp_Btn2: "View Archived EPRs",
    EPRApp_Semester: "Semester",
    EPRApp_1stSemester: "1st Semester",
    EPRApp_2ndSemester: "2nd Semester",
    /// ////////////////////////////////////////////////////////
    /// /////////// Assessment Excusals App ////////////////////
    /// ////////////////////////////////////////////////////////
    AEApp_Body: "Manage assessment opt-out requests.",
    AEApp_Header: "Assessment Excusals",
    AEApp_Excusal: "Excusal",
    AEApp_Excusals: "Excusals",
    AEApp_MoreExcusals: "Excusals",
    AEApp_NoExcusals: "No Excusals",
    AEApp_Btn1: "Go to Assessment Excusals",
    /// ////////////////////////////////////////////////////////
    /// /////////////// Transportation App /////////////////////
    /// ////////////////////////////////////////////////////////
    BusApp_Body1: "Apply for a bus pass and/or elect annual/quarterly payment options for bus rides.",
    BusApp_Body2: "Apply for a buss pass.",
    BusApp_Header: "Transportation",
    BusApp_Btn1: "Go to Transportation",
    BusApp_BusPass: "Bus Pass Issued",
    BusApp_NoBusPass: "No Bus Pass Issued",
    BusApp_NotRiding: "Not Riding",
    BusApp_NotRidingReason1: "You've indicated that", // <some student name>
    BusApp_NotRidingReason2: "will not be riding the bus this year.",
    BusApp_NotRidingReason3: "You've indicated that the student will not be riding the bus this year.",
    BusApp_Processing: "Bus Pass Processing",
    BusApp_AnnualOffer: "Annual Pass offer until", // <some date>
    BusApp_Quarterly: "You have elected Quarterly Billing. You can opt into Annual Billing by", // <some date>
    BusApp_BusPassIssued: (
        <>
            Your bus pass has been issued. You may now use the bus.
            <br />
            If a card is damaged or lost, a replacement bus pass can be requested through{" "}
            <a
                className="anchor"
                href="https://www.k12insight.com/Lets-Talk/DialogueCustom.aspx?k=WK3Z6DLT@DG2T5DLT"
                rel="noreferrer"
                target="_blank"
            >
                Let&apos;s Talk
            </a>
            .
        </>
    ),
    BusApp_BusPassProcessing: "Your Bus Pass application is still processing.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Loading Messages ////////////////////////
    /// /////////////////////////////////////////////////////////
    Loading_1: "Open Enrollment Loading",
    Loading_2: "Echeck-In Loading",
    Loading_3: "EPR Loading",
    Loading_4: "Assessment Excusals Loading",
    Loading_5: "Transportation Loading",
    Loading_6: "Survey Loading",
    Loading_7: "Broadcast Message Loading"
};
/* eslint-enable */
